import { useCalculateFetchedItems } from '../../hooks/useCalculateFetchItems';
import { useScrollFetchData } from '../../hooks/useScrollFetchData';
import { useMediaQuery, useTheme } from '@mui/material';
import { PersistedFixedSizeList as List } from "../../hooks/listNavigation";
import EquipmentGridData from './equipmentGridData';
import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import '../../css/machines/GridView.css';

const EquipmentGrid = React.memo(({ scrollRef, equipements, setOffset, filteredEquipementsCount, setEquipementsFetched }) => {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));

    // Determine the number of columns based on screen size
    const getColumns = () => {
        if (isXs) return 1;
        if (isSm) return 2;
        if (isMd) return 3;
        if (isLg) return 4;
        if (isXl) return 4;
        return 5; // Default
    };

    const columns = getColumns();

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    // Update window height on resize
    useEffect(() => {
        const handleResize = debounce(() => {
            setWindowHeight(window.innerHeight);
        }, 300); // 300ms debounce delay

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            handleResize.cancel(); // Cancel any pending debounced calls
        };
    }, []);

    // Calculate the number of rows based on the number of machines and columns
    const rowCount = Math.ceil(filteredEquipementsCount / columns);

    // Calculate fetched items on mount
    useCalculateFetchedItems(filteredEquipementsCount, setEquipementsFetched, 280, 215, columns);

    // Handle scroll and fetch more items
    const handleScrollCard = useScrollFetchData(setOffset, setEquipementsFetched, filteredEquipementsCount, 280, 215, columns);

    const Row = ({ index, style, data }) => {
        const { equipements, columns, filteredEquipementsCount } = data;
        return (
            <div key={index} style={style}>
                <EquipmentGridData
                    index={index}
                    data={{ equipements, columns, filteredEquipementsCount }}
                />
            </div>
        );
    };

    return (
        <List
            ref={scrollRef}
            height={windowHeight - 215}
            width='100%'
            itemCount={rowCount}
            itemSize={280}
            itemData={{ equipements, columns, filteredEquipementsCount }}
            onScroll={handleScrollCard}
        >
            {Row}
        </List>
    );
});

export default EquipmentGrid;